<template>
  <div class="aphrodite cypress-hook--offers-modal">
    <inquire-phone-number
      v-if="modalCurrentUiState === 'inquiry'"
      @update-phone="$emit('update-phone', $event)"></inquire-phone-number>
    <Modal
      v-if="modalCurrentUiState === 'review'"
      :closable="false"
      :shouldLimitHeight="false"
      :shouldNotHavePadding="true"
      modalSize="legacy">
      <div class="grid offer">
        <div class="header">{{agreementDisplayLabel}}</div>
        <div class="detail">
          <p class="leader" v-html="agreement.displayText"></p>
          <div class="inputs">
            <v-checkbox
              class="input"
              color="#26a69a"
              hide-details
              v-for="offer in agreement.offers"
              :key="offer.sortOrder"
              v-model="verticalIds[offer.verticalIds]">
              <template slot="label">
                <span class="label" v-html="offer.displayText"></span>
              </template>
            </v-checkbox>
          </div>
          <p class="legal" v-html="agreement.displayFinePrint"></p>
        </div>
        <div class="controls">
          <v-btn
            @click="$emit('cancel-offers')"
            color="#ff9800"
            class="control font-weight-medium"
            outline>{{buttonTextCancel}}</v-btn>
          <v-btn
            @click="$emit('submit-agreement', selectedVerticalIds)"
            :disabled="selectedVerticalIds.length === 0"
            color="#ff9800"
            class="control white--text font-weight-medium"
            plain>{{buttonTextContinue}}</v-btn>
        </div>
        <div class="disclaimers">
          <offers-policies></offers-policies>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/components/Shared/Modal.vue';
import InquirePhoneNumber from '@/components/OffersModalTemplates/shared/InquirePhoneNumber.vue';
import OffersPolicies from '@/components/OffersModalTemplates/shared/OffersPolicies.vue';

export default {
  components: { Modal, InquirePhoneNumber, OffersPolicies },
  props: [
    'agreement',
    'modalCurrentUiState',
    'verticalIds',
    'selectedVerticalIds',
    'buttonTextCancel',
    'buttonTextContinue',
  ],
  computed: {
    agreementDisplayLabel() {
      return this.agreement.displayLabel ? this.agreement.displayLabel : 'Agreements and Offers';
    },
  },
};
</script>

<style lang="scss" scoped>
.aphrodite {
  .grid {
    color: #404040;
    height: 100%;
    display: grid;
    height: 600px;
    max-height: 600px;
    min-height: -webkit-fill-available;
    overflow: hidden;
    padding: 20px 30px;
    grid-template-columns: 100%;
    grid-template-rows: 60px repeat(4, auto);
    grid-template-areas:
      'header'
      'detail'
      'controls'
      'disclaimers';

    .header {
      align-self: start;
      border-bottom: 2px solid #ff760a;
      color: black;
      font-size: 1.6em;
      font-weight: 500;
      grid-area: header;
      padding-bottom: 0.5em;
    }
    .detail {
      grid-area: detail;
      height: 100%;
      overflow-y: auto;
    }
    .leader {
      display: block;
      font-size: 1.2rem;
      font-weight: 500;
      font-weight: 600;
      margin-bottom: 1rem;
      text-align: left;
    }

    .inputs {
      margin-bottom: 1rem;
    }
    .input {
      .label {
        margin-bottom: inherit;
      }
    }

    .controls {
      background: white;
      display: flex;
      justify-content: center;
      align-self: flex-end;
      grid-area: controls;
      padding-top: 12px;
    }
    .disclaimers {
      grid-area: disclaimers;
      background: white;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .legal {
      font-size: 0.8rem;
      color: #404040;
      display: block;
    }
  }
}
</style>
